import { Injectable } from '@angular/core';
import {Restangular} from "ngx-restangular";
import {RestHttpService} from "@catcore/services/rest-http.service";

@Injectable()
export class ZoneAssignmentService extends RestHttpService<any> {

  constructor(private service: Restangular) {
    super('test-rack-zone-assignments', service);
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/test-rack/services/zone-assignment.service.ts